// FinMaple Mortgage Score — 5-pillar scoring for Canadian mortgage lenders
// Weights: Tasa 30%, Newcomer 25%, Flexibilidad 20%, Español 15%, Digital 10%

const WEIGHTS = {
  tasa: 0.30,
  newcomer: 0.25,
  flexibilidad: 0.20,
  espanol: 0.15,
  digital: 0.10,
};

// PILAR 1: Tasa (30%) — dynamic, compares lender rate vs best available
const calcTasa = (bankRate, bestRate) => {
  const diff = bankRate - bestRate;
  if (diff <= 0) return 5.0;
  if (diff <= 0.15) return 4.5;
  if (diff <= 0.30) return 4.0;
  if (diff <= 0.50) return 3.5;
  if (diff <= 0.75) return 3.0;
  if (diff <= 1.00) return 2.5;
  if (diff <= 1.50) return 2.0;
  return 1.5;
};

// PILAR 2: Newcomer-friendly (25%)
const NEWCOMER_RATINGS = {
  'RBC': 4.5,
  'Scotiabank': 4.5,
  'TD': 4.0,
  'CIBC': 4.0,
  'BMO': 3.5,
  'Desjardins': 3.5,
  'National Bank': 3.0,
  'Tangerine': 2.5,
  'Simplii Financial': 2.0,
  'Nesto': 4.0,
  'True North': 4.0,
  'Canwise (Ratehub)': 4.0,
  'MCAP': 3.0,
  'First National': 3.0,
};

// PILAR 3: Flexibilidad (20%) — prepago, portabilidad, penalidades
const FLEXIBILIDAD_RATINGS = {
  'RBC': 4.0,
  'Scotiabank': 3.5,
  'TD': 4.0,
  'CIBC': 3.5,
  'BMO': 3.5,
  'Desjardins': 3.5,
  'National Bank': 3.0,
  'Tangerine': 3.0,
  'Simplii Financial': 3.0,
  'Nesto': 4.5,
  'True North': 4.0,
  'Canwise (Ratehub)': 4.0,
  'MCAP': 3.5,
  'First National': 3.5,
};

// PILAR 4: Soporte en español (15%)
const ESPANOL_RATINGS = {
  'RBC': 3.5,
  'Scotiabank': 5.0,
  'TD': 4.0,
  'CIBC': 3.0,
  'BMO': 3.0,
  'Desjardins': 2.5,
  'National Bank': 2.0,
  'Tangerine': 2.5,
  'Simplii Financial': 2.5,
  'Nesto': 3.0,
  'True North': 3.0,
  'Canwise (Ratehub)': 2.5,
  'MCAP': 2.0,
  'First National': 2.0,
};

// PILAR 5: Digital (10%)
const DIGITAL_RATINGS = {
  'RBC': 4.0,
  'Scotiabank': 3.5,
  'TD': 4.0,
  'CIBC': 3.5,
  'BMO': 3.5,
  'Desjardins': 3.5,
  'National Bank': 3.0,
  'Tangerine': 4.5,
  'Simplii Financial': 4.0,
  'Nesto': 5.0,
  'True North': 4.5,
  'Canwise (Ratehub)': 4.5,
  'MCAP': 2.0,
  'First National': 2.0,
};

export function calculateMortgageScore(lenderName, lenderRate, bestAvailableRate) {
  const tasa = calcTasa(lenderRate, bestAvailableRate);
  const newcomer = NEWCOMER_RATINGS[lenderName] || 3.0;
  const flexibilidad = FLEXIBILIDAD_RATINGS[lenderName] || 3.0;
  const espanol = ESPANOL_RATINGS[lenderName] || 2.5;
  const digital = DIGITAL_RATINGS[lenderName] || 3.0;

  const total =
    tasa * WEIGHTS.tasa +
    newcomer * WEIGHTS.newcomer +
    flexibilidad * WEIGHTS.flexibilidad +
    espanol * WEIGHTS.espanol +
    digital * WEIGHTS.digital;

  return {
    total: Math.round(total * 20), // 0-100 scale
    breakdown: { tasa, newcomer, flexibilidad, espanol, digital },
  };
}

export { WEIGHTS as MORTGAGE_SCORE_WEIGHTS };
